import React from 'react';
import styles from '../catolico_tattoo/catolico_tattoo.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import TattooIcon from '../../icons/tattooIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Catolico_tattoo: React.FC = () => {

    return (
        <div className={styles.catolico_tattoo}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://wa.me/556596282556?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/N2U1Hps6Mz1By6Yg7"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://www.instagram.com/catolico_tattoo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                            title="INSTAGRAM"
                            spaceBetween={true}
                            icon={<InstagramIcon height="32" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            linkInterno={true}
                            href="/catolico_tattoo/galeria"
                            title="GALERIA"
                            icon={<TattooIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Catolico_tattoo;
